// @ts-ignore
import React from "react";

import { CheckemailPageTemplate } from "@/templates/ondemand/signup/checkemail/checkemail-page/src";

export const CheckemailPage = () => <CheckemailPageTemplate />;
